import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ADDITIONAL_SERVICE_OPTIONS } from '@webapp/core/constants/inquiry-labels';
import { CreateInquiryStep3 } from '@webapp/core/interfaces';
import { ToastrService } from 'ngx-toastr';
import {
  InquiryDraftSource,
  PublicInquiryManagerService,
} from 'projects/webapp/app/services/public-inquiry-manager.service';


/** Services: what the moving company should take on besides the move. */
@Component({
  selector: 'app-inquiry-step3',
  templateUrl: './step3.component.html',
})
export class InquiryStep3Component implements OnInit, OnDestroy {
  draftInquiryForm = new FormGroup({
    selected_additional_services: new FormControl<Set<string>>(new Set(), { nonNullable: true }),
    comment: new FormControl('', { nonNullable: true }),
  });

  additionalServices = ADDITIONAL_SERVICE_OPTIONS;

  protected _draftSource: InquiryDraftSource = () => ({ step3: this._buildPayload() });

  constructor(
    protected _toastrService: ToastrService,
    protected _publicInquiryManagerService: PublicInquiryManagerService,
  ) {
  }

  ngOnInit() {
    this._loadFormData();
    this._publicInquiryManagerService.setDraftSource(this._draftSource);
  }

  ngOnDestroy() {
    this._publicInquiryManagerService.clearDraftSource(this._draftSource);
  }

  onSubmit() {
    this.draftInquiryForm.markAllAsTouched();
    if (!this.draftInquiryForm.valid) {
      this._toastrService.warning('Bitte füllen Sie alle Pflichtfelder aus.');
      return;
    }

    this._publicInquiryManagerService.submitStep3(this._buildPayload())
  }

  goBack() {
    this._publicInquiryManagerService.goPrevStep()
  }

  isAdditionalServiceActive(value: string) {
    return this.draftInquiryForm.controls.selected_additional_services.value.has(value);
  }

  toggleAdditionalService(value: string) {
    const control = this.draftInquiryForm.controls.selected_additional_services;
    if (control.value.has(value)) control.value.delete(value);
    else control.value.add(value);
  }

  protected _loadFormData() {
    const step3Data = this._publicInquiryManagerService.inquiryCreationProgress?.step3;
    if (!step3Data) return;

    this.draftInquiryForm.patchValue({
      ...step3Data,
      selected_additional_services: new Set(step3Data.selected_additional_services)
    });
  }

  protected _buildPayload(): CreateInquiryStep3 {
    const controls = this.draftInquiryForm.controls;
    return {
      comment: controls.comment.value,
      selected_additional_services: [...controls.selected_additional_services.value],
    };
  }
}
